// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WC-z","smallCardRow":"XC-z","largeCardRow":"YC-z","productSearchRow":"ZC-z","curatedRow":"_C-z"};